"use client";

import { useGamePageData } from "@casino/ui/Games/hooks";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  TypographyH4,
} from "@workspace/frontend-ui";
import type { FC } from "react";
import GameStatsTable from "./GameStatsTable";
import LiveRtpStrip from "./LiveRtpStrip";

type Props = { game: SingleGameFragment; isLiveRtpEnabled?: boolean };

const GameStatsAccordion: FC<Props> = ({ game, isLiveRtpEnabled }) => {
  const { t } = useGamePageData();

  return (
    <Accordion type="single" collapsible>
      <AccordionItem value="game-info">
        <AccordionTrigger
          data-testid="info-accordion-trigger"
          className="bg-secondary px-4 rounded-lg flex justify-between items-center"
        >
          <TypographyH4 className="font-bold">
            {t("game.info.title", "Game info")}
          </TypographyH4>
        </AccordionTrigger>
        <AccordionContent>
          <LiveRtpStrip game={game} isLiveRtpEnabled={isLiveRtpEnabled} />
          <GameStatsTable game={game} />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default GameStatsAccordion;
